import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row mb-5 pb-5 justify-content-center" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "row p-0" }
const _hoisted_6 = { class: "col-12 p-0" }
const _hoisted_7 = { class: "card p-3 mb-4 bg-yellow-gradient border-radius-10 d-block" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Account Type")
  ]),
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-12 mt-2" }, " Fund Management ")
], -1)
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Balance")
], -1)
const _hoisted_12 = { class: "font-white font-size-12 mt-2" }
const _hoisted_13 = { class: "row mt-3" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Name")
], -1)
const _hoisted_16 = { class: "font-white font-size-12 mt-2" }
const _hoisted_17 = {
  class: "col-6",
  style: {"overflow-y":"auto","max-height":"125px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "row mt-3" }
const _hoisted_20 = { class: "col-6 ac-last-first-c" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Reference")
], -1)
const _hoisted_22 = { class: "font-white font-size-12 mt-2" }
const _hoisted_23 = { class: "col-6 ac-last-first-c" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Date Account Established ")
], -1)
const _hoisted_25 = { class: "font-white font-size-12 mt-2" }
const _hoisted_26 = { class: "col-12 p-0" }
const _hoisted_27 = { class: "card p-0 bg-white border-radius-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-white border-bottom",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 d-block text-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey m-0" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Portfolio")
    ])
  ])
], -1)
const _hoisted_29 = { class: "row my-3 justify-content-center" }
const _hoisted_30 = { class: "col-md-12 px-4 py-2" }
const _hoisted_31 = { class: "card p-2 bg-card-grey border-radius-10" }
const _hoisted_32 = { class: "row mt-3 mx-1" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "form-control bg-white d-flex justify-content-between p-3" }
const _hoisted_35 = { class: "width-110 font-grey font-size-12" }
const _hoisted_36 = { class: "font-grey font-size-12" }
const _hoisted_37 = { class: "font-grey font-size-12" }
const _hoisted_38 = { class: "col-md-12 p-0" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = {
  class: "form-control d-flex justify-content-between p-3",
  style: {"background":"#6F7F9B!important"}
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("b", { class: "width-110 font-white font-size-12" }, "Total", -1)
const _hoisted_42 = { class: "font-white font-size-12" }
const _hoisted_43 = { class: "col-md-8" }
const _hoisted_44 = { class: "p-0 bg-white border-radius-10" }
const _hoisted_45 = {
  class: "row m-0 bg-white border-bottom",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_46 = { class: "col-md-7 d-flex justify-content-start align-items-center py-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("b", { style: {"margin":"10px","color":"#ff7d00","cursor":"pointer"} }, "Transactions", -1)
const _hoisted_48 = { class: "row px-3" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-12 d-flex align-items-center justify-content-between" }
const _hoisted_51 = { class: "font-size-12 font-gray2 m-0" }
const _hoisted_52 = { class: "btn btn-dark pw4 mh-17 font-size-10 text-uppercase mr-1" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "font-size-16 m-0" }, "|", -1)
const _hoisted_54 = { class: "font-size-12 font-gray2 m-0" }
const _hoisted_55 = { class: "text-success" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", { class: "font-size-16 m-0" }, "|", -1)
const _hoisted_57 = { class: "font-size-12 font-gray2 m-0" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", { class: "font-size-16 m-0" }, "|", -1)
const _hoisted_59 = { class: "font-size-12 font-gray2 m-0" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "font-size-16 m-0" }, "|", -1)
const _hoisted_61 = { class: "font-size-12 font-gray2 m-0" }
const _hoisted_62 = { class: "row px-3" }
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<div class=\"col-4 d-flex align-items-center mt-3 pl-2\"><p class=\"font-grey font-size-17 m-0 f-weight-600\">Deposit</p></div><div class=\"col-4 d-flex align-items-center mt-3 pl-2\"><p class=\"font-grey font-size-17 m-0 f-weight-600\">Withdrawal</p></div><div class=\"col-4 d-flex align-items-center mt-3 pl-2\"><p class=\"font-grey font-size-17 m-0 f-weight-600\">Investment</p></div>", 3)
const _hoisted_66 = {
  class: "col-4 border-right mt-2 px-1",
  style: {"overflow-y":"overlay","max-height":"230px"}
}
const _hoisted_67 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_68 = { class: "font-gray2 font-size-14 p-1 border-bottom mb-4" }
const _hoisted_69 = { class: "font-gray2 border-bottom font-size-16 p-1 d-flex" }
const _hoisted_70 = { class: "btn btn-dark pw4 mh-17 font-size-10 text-uppercase" }
const _hoisted_71 = { class: "font-gray2 font-size-14 m-0" }
const _hoisted_72 = { class: "ml-2" }
const _hoisted_73 = {
  key: 0,
  class: "font-red"
}
const _hoisted_74 = { class: "font-gray2" }
const _hoisted_75 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_76 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_77 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_78 = {
  key: 0,
  class: "text-center font-gray2 font-size-14 p-1"
}
const _hoisted_79 = {
  class: "col-4 border-right mt-2 px-1 y-overlay-230",
  style: {"overflow-y":"overlay","max-height":"230px"}
}
const _hoisted_80 = { class: "font-gray2 border-bottom font-size-16 p-1 d-flex" }
const _hoisted_81 = { class: "btn btn-dark pw4 mh-17 font-size-10 text-uppercase" }
const _hoisted_82 = { class: "font-gray2 font-size-14 m-0" }
const _hoisted_83 = { class: "ml-2" }
const _hoisted_84 = {
  key: 0,
  class: "font-red"
}
const _hoisted_85 = { class: "font-gray2" }
const _hoisted_86 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_87 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_88 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_89 = {
  key: 0,
  class: "text-center font-gray2 font-size-14 p-1"
}
const _hoisted_90 = {
  class: "col-4 mt-2 px-1 y-overlay-200",
  style: {"overflow-y":"overlay","max-height":"230px"}
}
const _hoisted_91 = { class: "font-gray2 border-bottom font-size-16 p-1 d-flex" }
const _hoisted_92 = { class: "btn btn-dark pw4 mh-17 font-size-10 text-uppercase" }
const _hoisted_93 = { class: "font-gray2 font-size-14 m-0" }
const _hoisted_94 = { class: "ml-2" }
const _hoisted_95 = {
  key: 0,
  class: "font-red"
}
const _hoisted_96 = { class: "font-gray2" }
const _hoisted_97 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_98 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_99 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_100 = { class: "font-gray2 border-bottom font-size-14 p-1" }
const _hoisted_101 = {
  key: 0,
  class: "text-center font-gray2 font-size-14 p-1"
}
const _hoisted_102 = {
  key: 0,
  class: "justify-content-center row p-3 transaction-list",
  style: {"height":"auto"}
}
const _hoisted_103 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No Funds Found", -1)
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = { class: "my-4 p-0 bg-white border-radius-10" }
const _hoisted_106 = {
  class: "row m-0",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_107 = { class: "col-md-12 d-flex justify-content-start border-bottom align-items-center py-2" }
const _hoisted_108 = { class: "nav chart-nav justify-content-between" }
const _hoisted_109 = { class: "nav-item" }
const _hoisted_110 = { class: "nav-item" }
const _hoisted_111 = { class: "nav-item" }
const _hoisted_112 = { class: "nav-item" }
const _hoisted_113 = { class: "nav-item" }
const _hoisted_114 = {
  key: 0,
  class: "row"
}
const _hoisted_115 = {
  key: 0,
  class: "col-md-12 mt-4 pt-2 d-flex justify-content-start align-items-center chartDiv",
  id: "lastMonthDiv"
}
const _hoisted_116 = { class: "p-2 mx-auto line-chart" }
const _hoisted_117 = {
  id: "chart1",
  style: {"height":"250px"}
}
const _hoisted_118 = {
  key: 1,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "threeMonthDiv"
}
const _hoisted_119 = { class: "p-2 mx-auto line-chart" }
const _hoisted_120 = {
  id: "chart2",
  style: {"height":"250px"}
}
const _hoisted_121 = {
  key: 2,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "sixMonthDiv"
}
const _hoisted_122 = { class: "p-2 mx-auto line-chart" }
const _hoisted_123 = {
  id: "chart3",
  style: {"height":"250px"}
}
const _hoisted_124 = {
  key: 3,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "yearChartDiv"
}
const _hoisted_125 = { class: "p-2 mx-auto line-chart" }
const _hoisted_126 = {
  id: "chart4",
  style: {"height":"250px"}
}
const _hoisted_127 = {
  key: 4,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "allTimeDiv"
}
const _hoisted_128 = { class: "p-2 mx-auto line-chart" }
const _hoisted_129 = {
  id: "chart5",
  style: {"height":"250px"}
}
const _hoisted_130 = {
  key: 1,
  class: "row"
}
const _hoisted_131 = /*#__PURE__*/_createElementVNode("p", { class: "col-md-12 font-grey text-center" }, " Loading...", -1)
const _hoisted_132 = [
  _hoisted_131
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.default_currency) + " " + _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(_ctx.fund.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.fund.userac_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subac, (subac) => {
                        return (_openBlock(), _createElementBlock("h5", {
                          class: "font-white font-size-12 mt-2",
                          key: subac.subac_id
                        }, [
                          _createTextVNode(_toDisplayString(subac.subac_name), 1),
                          _hoisted_18,
                          _createTextVNode(" " + _toDisplayString(subac.currency_name) + " " + _toDisplayString(subac.currency_symbol) + _toDisplayString(subac.subac_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("h5", _hoisted_22, " #" + _toDisplayString(_ctx.fund.userac_reference_code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.fund.userac_establish_date), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-md-12 p-0",
                              key: ac.userac_id
                            }, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("b", _hoisted_35, _toDisplayString(ac.ac_name), 1),
                                  _createElementVNode("p", _hoisted_36, _toDisplayString(ac.ac_percent.toFixed()) + " % ", 1),
                                  _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                                ])
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(_ctx.total_active_default_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createTextVNode(" | "),
                  _createElementVNode("b", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {this.$router.push('/fundac-fees');}),
                    style: {"margin":"10px","cursor":"pointer"},
                    class: "font-grey"
                  }, "Fees")
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subac, (fund) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-12 px-1 py-3 border-bottom",
                    key: fund.subac_id
                  }, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("p", _hoisted_51, [
                          _createElementVNode("button", _hoisted_52, _toDisplayString(fund.currency_name), 1),
                          _createTextVNode(" " + _toDisplayString(fund.fund_name), 1)
                        ]),
                        _hoisted_53,
                        _createElementVNode("p", _hoisted_54, [
                          _createTextVNode("Not Invested "),
                          _createElementVNode("span", _hoisted_55, _toDisplayString(fund.currency_symbol) + " " + _toDisplayString(fund.subac_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                        ]),
                        _hoisted_56,
                        _createElementVNode("p", _hoisted_57, [
                          _createTextVNode("Growth "),
                          _createElementVNode("span", null, _toDisplayString(fund.currency_symbol) + _toDisplayString(fund.growth.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                        ]),
                        _hoisted_58,
                        _createElementVNode("p", _hoisted_59, [
                          _createTextVNode("Yield "),
                          _createElementVNode("span", null, _toDisplayString(fund.currency_symbol) + _toDisplayString(fund.fund_yield.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                        ]),
                        _hoisted_60,
                        _createElementVNode("p", _hoisted_61, [
                          _createTextVNode("Return "),
                          _createElementVNode("span", null, _toDisplayString(fund.currency_symbol) + _toDisplayString((fund.fund_investor_return).toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, " Balance " + _toDisplayString(fund.currency_symbol) + _toDisplayString((fund.subac_currency_balance).toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1),
                        _createElementVNode("div", _hoisted_68, " Fund Valuation " + _toDisplayString(fund.currency_symbol) + _toDisplayString((fund.subac_currency_balance).toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fund.deposits, (deposit) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: deposit.trans_id
                          }, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("button", _hoisted_70, _toDisplayString(deposit.currency_name), 1),
                              _createElementVNode("p", _hoisted_71, [
                                _createElementVNode("span", _hoisted_72, [
                                  (deposit.trans_type==1)
                                    ? (_openBlock(), _createElementBlock("b", _hoisted_73, "-"))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(deposit.currency_symbol) + _toDisplayString(deposit.trans_currency_total), 1)
                                ]),
                                _createElementVNode("small", _hoisted_74, " ( " + _toDisplayString(deposit.currency_symbol) + " " + _toDisplayString(deposit.trans_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) + " rate " + _toDisplayString(deposit.trans_currency_rate.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 10})) + ") ", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_75, _toDisplayString(deposit.t_time), 1),
                            _createElementVNode("div", _hoisted_76, " Ref#" + _toDisplayString(deposit.trans_reference_no), 1),
                            _createElementVNode("div", _hoisted_77, _toDisplayString(deposit.trans_description?deposit.trans_description:'-'), 1)
                          ]))
                        }), 128)),
                        (!fund.deposits.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, "No Withdrawls Found"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fund.withdrawls, (withd) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: withd.trans_id
                          }, [
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("button", _hoisted_81, _toDisplayString(withd.currency_name), 1),
                              _createElementVNode("p", _hoisted_82, [
                                _createElementVNode("span", _hoisted_83, [
                                  (withd.trans_type==1)
                                    ? (_openBlock(), _createElementBlock("b", _hoisted_84, "-"))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(withd.currency_symbol) + _toDisplayString(withd.trans_currency_total), 1)
                                ]),
                                _createElementVNode("small", _hoisted_85, " ( " + _toDisplayString(withd.currency_symbol) + " " + _toDisplayString(withd.trans_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) + " rate " + _toDisplayString(withd.trans_currency_rate.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 10})) + ") ", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_86, _toDisplayString(withd.trans_description?withd.trans_description:'-'), 1),
                            _createElementVNode("div", _hoisted_87, _toDisplayString(withd.t_time), 1),
                            _createElementVNode("div", _hoisted_88, " Ref#" + _toDisplayString(withd.trans_reference_no), 1)
                          ]))
                        }), 128)),
                        (!fund.withdrawls.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, "No Withdrawls Found"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fund.investments, (invst) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: invst.trans_id
                          }, [
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("button", _hoisted_92, _toDisplayString(invst.currency_name), 1),
                              _createElementVNode("p", _hoisted_93, [
                                _createElementVNode("span", _hoisted_94, [
                                  (invst.trans_type==1)
                                    ? (_openBlock(), _createElementBlock("b", _hoisted_95, "-"))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(invst.currency_symbol) + _toDisplayString(invst.trans_currency_total), 1)
                                ]),
                                _createElementVNode("small", _hoisted_96, " ( " + _toDisplayString(invst.currency_symbol) + " " + _toDisplayString(invst.trans_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) + " rate " + _toDisplayString(invst.trans_currency_rate.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 10})) + ") ", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_97, _toDisplayString(invst.trans_description?invst.trans_description:'-'), 1),
                            _createElementVNode("div", _hoisted_98, _toDisplayString(invst.t_time), 1),
                            _createElementVNode("div", _hoisted_99, " Ref#" + _toDisplayString(invst.trans_reference_no), 1),
                            _createElementVNode("div", _hoisted_100, " Investment period " + _toDisplayString(invst.investment_period), 1)
                          ]))
                        }), 128)),
                        (!fund.investments.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_101, "No Investments Found"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              (!_ctx.subac.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_102, _hoisted_104))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("ul", _hoisted_108, [
                    _createElementVNode("li", _hoisted_109, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (this.active_chart=1)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==1}, "font-grey lastMonth chartBtn"])
                        }, "Last Month", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_110, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (this.active_chart=2)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==2}, "font-grey threeMonth chartBtn"])
                        }, "3M", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_111, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (this.active_chart=3)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==3}, "font-grey sixMonth chartBtn"])
                        }, "6M", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_112, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (this.active_chart=4)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==4}, "font-grey yearChart chartBtn"])
                        }, "Year", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_113, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (this.active_chart=5)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==5}, "font-grey allTime chartBtn"])
                        }, "All", 2)
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.on_chart==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                    (_ctx.active_chart==1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions1,
                                series: _ctx.series1
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("div", _hoisted_120, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions2,
                                series: _ctx.series2
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                          _createElementVNode("div", _hoisted_122, [
                            _createElementVNode("div", _hoisted_123, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions3,
                                series: _ctx.series3
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                          _createElementVNode("div", _hoisted_125, [
                            _createElementVNode("div", _hoisted_126, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions4,
                                series: _ctx.series4
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                          _createElementVNode("div", _hoisted_128, [
                            _createElementVNode("div", _hoisted_129, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions5,
                                series: _ctx.series5
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.on_chart==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_130, _hoisted_132))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}